import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const WithdrawalTransactionPayloadSchema = z
    .object({
        transactions: z.array(z.string()).optional(),
        note: z.string().optional(),
    })
    .strict();

export class WithdrawalTransactionPayload extends FromSchema(WithdrawalTransactionPayloadSchema) {
    transactions?: string[];
    note?: string;
}
